<template>
  <base-dropdown>
    <template #title>
      <button
        class="btn btn-primary dropdown-toggle btn-block"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Tuỳ chọn
      </button>
    </template>
    <a
      v-if="!permission || $permission(permission.create)"
      class="dropdown-item"
      :class="{ disabled: !countChecked || countChecked > 1 }"
      @click="$emit('copy')"
      href="#"
    >
      <i class="far fa-copy"></i>
      Sao chép
    </a>
    <a
      v-if="!permission || $permission(permission.delete)"
      :class="{ disabled: countChecked == 0 }"
      class="dropdown-item"
      @click="doDelete"
      href="#"
    >
      <i class="far fa-trash-alt text-danger"></i>
      Xóa dòng đã chọn ({{ countChecked }})
    </a>
    <!-- <a class="dropdown-item" v-if="help" @click="help" href="#">
      <i class="fa fa-question-circle text-warning"></i>
      Hướng dẫn
    </a> -->
  </base-dropdown>
</template>

<script>
export default {
  name: "option-button",
  props: {
    permission: {
      type: Object
    },
    help: {
      type: Function
    },
    countChecked: {
      type: Number,
      required: true
    }
  },
  methods: {
    doDelete: function() {
      var self = this;
      if (this.countChecked == 0) {
        this.$swal({
          title: "Chưa chọn dòng nào",
          text: "Vui lòng chọn 1 dòng để thực hiện thao tác này !",
          type: "warning",
          confirmButtonText: "OK, Tôi hiểu rồi !"
        });
      } else {
        this.$swal({
          title: "Bạn có chắc thực hiện thao tác này?",
          text: "Bạn sẽ không thể hoàn nguyên điều này!!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Không",
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            self.$emit("doDelete");
          }
        });
      }
    }
  }
};
</script>

<style></style>
